<ctx-algolia-avatar [user]="user()" />

<div class="global-search-user__information">
	<p class="m-0">
		<tui-icon icon="@tui.user" />
		@if (user().name; as name) {
			{{ name }}
		} @else {
			{{ user().metadata.email }}
		}
	</p>

	<small class="m-0">
		{{ 'user.roles.' + user().metadata.role | transloco }}
		<span class="margin-h-1">•</span>
		{{ user().metadata.email }}
	</small>
</div>
